import { render, staticRenderFns } from "./Items-list.vue?vue&type=template&id=8ef17aaa&scoped=true"
import script from "./Items-list.vue?vue&type=script&lang=js"
export * from "./Items-list.vue?vue&type=script&lang=js"
import style0 from "./Items-list.vue?vue&type=style&index=0&id=8ef17aaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef17aaa",
  null
  
)

export default component.exports